module.exports = (
  $scope,
  $rootScope,
  $filter,
  Api,
  bulkUploadMapping,
  bulkUploadGeneratorData,
) ->
  #
  # View
  #
  $scope.tab = "raw"

  # This function is added because `ng-if` will created a child scope,
  # so should call a function to set values in parent scope.
  $scope.setTab = (tab) ->
    $scope.tab = tab

  #
  # State
  #
  $scope.isEditing = ->
    $scope.bulkUploadMapping?.id?

  $scope.bulkUploadMapping = bulkUploadMapping
  $scope.rawMapping = "{}"
  $scope.mappingType = "report"

  if $scope.isEditing()
    $scope.rawMapping = $filter("json")($scope.bulkUploadMapping.mapping)
    $scope.mappingType = $scope.bulkUploadMapping.mapping_type

  $scope.canSave = ->
    $scope.bulkUploadMapping?.name?.length > 0 and $scope.mappingType and $scope.rawMapping?.length > 0

  #
  # Handlers
  #
  $scope.getMappingSchema = ->
    bulkUploadGeneratorData.getSchema($scope.mappingType)

  $scope.getMappingTemplate = ->
    bulkUploadGeneratorData.getTemplate($scope.mappingType)

  $scope.handleGenerate = (generatedMapping) ->
    $scope.rawMapping = $filter("json")(generatedMapping)

  #
  #
  # Actions
  #
  $scope.saving = false

  alreadyExists = (string, results) ->
    if typeof results is 'object' and results.hasOwnProperty('length')
      for result in results
        if result.name == string
          return true
    return false

  handleSave = ->
    $scope.saving = false
    $rootScope.message = "Mapping successfully saved as '".concat $scope.bulkUploadMapping.name.concat "'"

  $scope.handleSave = =>
    $scope.saving = true

    Api.BulkUploadMappings.get().$promise.then (result) ->
      if !$scope.isEditing() and alreadyExists($scope.bulkUploadMapping.name, result.results)
        numberPosition = $scope.bulkUploadMapping.name.search(/\([0-9]+\)$/)
        if numberPosition == -1
          originalName = $scope.bulkUploadMapping.name
        else
          originalName = $scope.bulkUploadMapping.name.slice 0, numberPosition
        name = originalName
        count = 2
        while alreadyExists(name, result.results)
          name = originalName.concat "(".concat count.toString().concat ")"
          count++

        $scope.bulkUploadMapping.name = name

      bulkUploadMapping = new Api.BulkUploadMappings
        id: $scope.bulkUploadMapping.id if $scope.isEditing()
        name: $scope.bulkUploadMapping.name
        mapping: $scope.rawMapping
        mapping_type: $scope.mappingType
      
      if $scope.isEditing()
        return bulkUploadMapping.$update().then handleSave
      else
        return bulkUploadMapping.$save().then handleSave
